
import { StationUnit } from "@/models/stationUnit.js"
import { STAB_PARMS } from "@/app.conf"




export class PowerUnit extends StationUnit {
	// Passport keys in DB
	static get passportKeys() {
		return Object.freeze({
			self: 'power_unit',
			unitVersion: 'unit_version',
			unitPort: 'unit_port',
			unitModbusAddr: 'unit_modbus_addr',
			operaionAndProtectionStartDate: 'operaion_and_protection_start_date',
		})
	}

	// Metric keys in DB
	static get metricKeys() {
		return Object.freeze({
			stationState: 'station_state',

			// Stabilization values in unit registers
			stationStabilizationMode: 'station_mode',
			stationStabilizationCurent: 'stabilization_current_actual_value',
			stationStabilizationVoltage: 'stabilization_voltage_actual_value',
			stationStabilizationPotential: 'stabilization_potential_actual_value',

			// Stabilization settings last user writes
			stabilizationModeSetting: 'stabilization_mode_setting',
			stabilizationValueSetting: 'stabilization_value_setting',

			iOut: 'Iout',
			uOut: 'Uout',
			eOut: 'Uprotect_sum',
			lastConnection: 'last_connection',
			operationTime: 'operation_time',
			protectionTime: 'time_protect',
			transistorsTemperature: 'transistors_temperature',
			// alerts
			fault: 'fault',
			shortCircuitLoad: 'short_circuit_load',
			breakCurrentSensor: 'break_current_sensor',
			breakTemperatureSensor: 'break_temperature_sensor',
			break: 'break',
			overheat: 'overheat',
			hiTrasholdU220: 'hi_trashold_u220',
			lowTrasholdU220: 'low_trashold_u220',
			shortCircuitInvertor: 'short_circuit_invertor',
			u220Error: 'u220_error',
			pwmControllerError: 'pwm_controller_error',
			protectTimeExpired: 'protect_time_expired',
			// Flags
			fBreakCurrent: 'f_break_current',
			fBreakPotential: 'f_break_potential',
			//
			isConnect: 'is_connection',
		})
	}

	static get alertKeys() {
		return [
			PowerUnit.metricKeys.fault,
			PowerUnit.metricKeys.shortCircuitLoad,
			PowerUnit.metricKeys.breakCurrentSensor,
			PowerUnit.metricKeys.breakTemperatureSensor,
			PowerUnit.metricKeys.break,
			PowerUnit.metricKeys.overheat,
			PowerUnit.metricKeys.hiTrasholdU220,
			PowerUnit.metricKeys.lowTrasholdU220,
			PowerUnit.metricKeys.shortCircuitInvertor,
			PowerUnit.metricKeys.u220Error,
			PowerUnit.metricKeys.pwmControllerError,
			PowerUnit.metricKeys.protectTimeExpired,
		]
	}

	static alertPromt(alertKey) {
		const matchingTable = new Object ()
		matchingTable[PowerUnit.metricKeys.fault] = 'несправність силового модуля станції'
		matchingTable[PowerUnit.metricKeys.shortCircuitLoad] = 'КЗ у навантаженні'
		matchingTable[PowerUnit.metricKeys.breakCurrentSensor] = 'обрив датчика струму'
		matchingTable[PowerUnit.metricKeys.breakTemperatureSensor] = 'обрив датчика температури'
		matchingTable[PowerUnit.metricKeys.break] = 'обрив вимірювальних ланцюгів'
		matchingTable[PowerUnit.metricKeys.overheat] = 'перегрів'
		matchingTable[PowerUnit.metricKeys.hiTrasholdU220] = 'підвищена напруга мережі'
		matchingTable[PowerUnit.metricKeys.lowTrasholdU220] = 'низька напруга мережі'
		matchingTable[PowerUnit.metricKeys.shortCircuitInvertor] = 'КЗ у інверторі'
		matchingTable[PowerUnit.metricKeys.u220Error] = 'порушення напруги живлення'
		matchingTable[PowerUnit.metricKeys.pwmControllerError] = 'помилка ШІМ-контроллера'
		matchingTable[PowerUnit.metricKeys.protectTimeExpired] = 'час роботи інвертора стік'

		return matchingTable[alertKey]
	}

	// Unit versions
	static get versions() {
		return Object.freeze({
			v2017: '2017',
			v2022: '2022',
			v2025: '2025',
			v2025t: '2025t',
			ipau: 'IPAU',
			monitoring: 'monitoring',
			mcps: 'MCPS',
			aipd: 'unknown',
			opek: 'OPEK',
			unknown: 'unknown',
		})
	}

	// Unit version names
	static get versionNames() {
		return Object.freeze({
			[PowerUnit.versions.v2017]: 'ВППС 2017',
			[PowerUnit.versions.v2022]: 'ВППС 2022',
			[PowerUnit.versions.v2025]: 'ВППС 2025',
			[PowerUnit.versions.v2025t]: 'ВППС 2025/Т',
			[PowerUnit.versions.ipau]: 'ІПАУ',
			[PowerUnit.versions.monitoring]: 'УКЗ моніторинг',
			[PowerUnit.versions.mcps]: 'ВППС-ПДП',
			[PowerUnit.versions.aipd]: 'АІПД',
			[PowerUnit.versions.opek]: 'В-ОПЕК',
			[PowerUnit.versions.unknown]: 'СКЗ інші',
		})
	}

	// Unit setting names for interface
	static get settingNames() {
		return Object.freeze({
			[PowerUnit.passportKeys.unitVersion]: 'Версія силового модуля',
			[PowerUnit.passportKeys.unitPort]: 'Порт силового модуля',
			[PowerUnit.passportKeys.unitModbusAddr]: 'ModBus адреса силового модуля',
			[PowerUnit.passportKeys.operaionAndProtectionStartDate]:
				'Початкова дата нарахування годин напрацювання та часу захисту споруди',		
		})
	}

	get passport() {
		return this._passport.get(PowerUnit.passportKeys.self)
	}

	// Return true if unit version is not unknown
	get isPresent() {
		if (!this.passport 
			|| !this.passport[PowerUnit.passportKeys.unitVersion]
			|| this.passport[PowerUnit.passportKeys.unitVersion] == PowerUnit.versions.unknown
		) {
			return false
		} else {
			return true
		}
	}

	// Return unit connection metric
	get isConnect() {
		// If not present
		if (!this.isPresent) {
			return false
		}

		if (this.metrics.has(PowerUnit.metricKeys.isConnect)) {
			return this.metrics.get(PowerUnit.metricKeys.isConnect).value
		} else {
			return false
		}
	}

	get connectionText() {
		return PowerUnit.connectionText(this.isConnect)
	}

	get stateText() {
		if (!this.getMetric(PowerUnit.metricKeys.stationState))
			return '-'

		return PowerUnit.stateText(this.getMetric(PowerUnit.metricKeys.stationState).value)
	}

	static stateText(code) {
		// Mapping mode code, generate mode string
		switch (code) {
			case 0:
				return "зупинений"
			case 1:
				return "запущений"
			default:
				return "невідомий"
		}
	}

	get stabilizationModeText() {
		if (!this.getMetric(PowerUnit.metricKeys.stationStabilizationMode))
			return '-'

		// Mapping mode code, generate mode string
		return PowerUnit.stabilizationModeText(
			this.getMetric(PowerUnit.metricKeys.stationStabilizationMode)?.value,
		)
	}

	static stabilizationModeText(mode, values=undefined, powerUnitVersion=undefined) {
		let text = ''

		// Mapping mode code, generate mode string
		switch (Number(mode)) {
			case 0:
				text = "струм"
				break
			case 1:
				text = "потенціал"
				break
			case 2:
				text = "потенціал"
				break
			case 3:
				text = "напруга"
				break
			case 4:
				text = "mix"
				break
			default:
				return "-"
		}

		if (values == undefined
			|| powerUnitVersion == undefined
			|| ![
					PowerUnit.versions.v2022,
					PowerUnit.versions.v2025,
					PowerUnit.versions.v2025t,
				].includes(powerUnitVersion)
		) {
			return text
		}
		
		switch (Number(mode)) {
			case 0: {
				const value = values[PowerUnit.metricKeys.stationStabilizationCurent]
					? Number(
						values[PowerUnit.metricKeys.stationStabilizationCurent]
					).toFixed(1)
					: '-'
				text += value == '-' ? '' : `\xa0=\xa0${value}\xa0${STAB_PARMS.I.unit}`
				break
			}
			case 1: {
				const value = values[PowerUnit.metricKeys.stationStabilizationPotential]
					? Number(
						values[PowerUnit.metricKeys.stationStabilizationPotential]
					).toFixed(2)
					: '-'
				text += value == '-'
					? ''
					: `\xa0=\xa0${value.charAt(0) == '-' ? value : '-' + value}\xa0${STAB_PARMS.E.unit}`
				break
			}
			case 2: {
				const value = values[PowerUnit.metricKeys.stationStabilizationPotential]
					? Number(
						values[PowerUnit.metricKeys.stationStabilizationPotential]
					).toFixed(2)
					: '-'
				text += value == '-'
					? ''
					: `\xa0=\xa0${value.charAt(0) == '-' ? value : '-' + value}\xa0${STAB_PARMS.E.unit}`
				break
			}
			case 3: {
				const value = values[PowerUnit.metricKeys.stationStabilizationVoltage]
					? Number(
						values[PowerUnit.metricKeys.stationStabilizationVoltage]
					).toFixed(1)
					: '-'
				text += value == '-' ? '' : `\xa0=\xa0${value}\xa0${STAB_PARMS.U.unit}`
				break
			}
			case 4:
				break
		}

		return text
	}
}